<!--
 * @Description : 系统维护升级页面
 * @Author      : pishengjun
 * @Date        : 2026-01-15 11:27:26
-->
<template>
  <div class="upgrade">
    <div class="maintenance-container">
      <div class="maintenance-content">
        <div class="icon-wrapper">
          <div class="maintenance-icon">
            <img class="icon" src="@/assets/images/upgradeIco.jpg" />
          </div>
          <!-- <svg-icon icon-class="maintenance" class="maintenance-icon" /> -->
        </div>
        <h1 class="title">系统维护升级中</h1>
        <p class="description">{{ message }}</p>
        <!-- <p class="sub-description">预计完成时间: 2026-01-15 18:00</p> -->
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, toRefs, onMounted } from "vue";
import { store } from "@/store";

export default defineComponent({
  setup() {
    onMounted(() => {
      state.message = store.state.upgradeData?.message || "系统维护升级中，请稍后再试。";
    });

    const state = reactive({
      message: "",
    });
    const event = {};

    return {
      ...toRefs(state),
      ...event,
    };
  },
});
</script>

<style lang="less" scoped>
.upgrade {
  height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  display: flex;
  align-items: center;
  justify-content: center;

  .maintenance-container {
    background: white;
    border-radius: 16px;
    padding: 40px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    max-width: 500px;
    width: 90%;
    text-align: center;

    .maintenance-content {
      .icon-wrapper {
        margin-bottom: 24px;
        display: flex;
        justify-content: center;
        .maintenance-icon {
          width: 160px;
          height: 160px;
          color: #4a6cf7;
          background: #f9f9f9;
          .icon {
            width: 100%;
            height: 100%;
          }
        }
      }

      .title {
        font-size: 24px;
        font-weight: 600;
        color: #333;
        margin-bottom: 20px;
      }

      .description {
        font-size: 16px;
        color: #666;
        margin-bottom: 10px;
        line-height: 1.8;
      }

      .sub-description {
        font-size: 14px;
        color: #999;
        margin-top: 24px;
      }
    }
  }
}
</style>
